import React, { useState, useEffect } from 'react';
import { IonButton, IonIcon, IonRow } from '@ionic/react';
import MomentUtils from '@date-io/moment';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import moment, { Moment } from 'moment';

import API from '../../api/index';
import { Currency } from '../../models/Currency';
import { RootState } from '../../models/RootState';
import { PLStatement } from '../../models/PLStatement';
import { AuthResponse } from '../../models/api/AuthResponse';
import Spinner from '../../components/Spinner/Spinner';
import Alert from '../../components/Alert/Alert';
import { fetchBettingCurrency, getCurrencyTypeFromToken } from '../../store';
import ProfitLossStatement from '../../components/ProfitLossStatement/ProfitLossStatement';
import './UserPLStatement.scss';
import { connect } from 'react-redux';
import AccStmtImg from '../../assets/images/icons/dollar.svg';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import REPORTING_API from '../../api-services/reporting-api';

type StoreProps = {
  fetchBettingCurrency: Function;
  bettingCurrency: Currency;
  allowedConfig: number;
  langData:any;
};

const UserPLStatement: React.FC<StoreProps> = (props) => {
  const { fetchBettingCurrency, bettingCurrency, allowedConfig,langData } = props;

  const [errorMsg, setErrorMsg] = useState(null);
  const [progress, setProgress] = useState<Boolean>(false);
  const [plStatement, setplStatement] = useState<Map<string, PLStatement[]>>(
    new Map()
  );
  const [fromDate, setfromDate] = useState<Moment>(moment().subtract(7, 'd'));
  const [toDate, setToDate] = useState<Moment>(moment());
  const [pageToken, setPageToken] = useState<string[]>(['']);
  const [nextPageToken, setNextPageToken] = useState<string>('');
  const pageSize = 25;
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];

  // useEffect(() => {
  //   fetchBettingCurrency();
  // }, [fetchBettingCurrency]);

  const fetchPLStatement = async () => {
    setProgress(true);
    setErrorMsg(null);
    try {
      // if (!bettingCurrency) return false;

      const response: AuthResponse = await REPORTING_API.post(
        '/reports/v2/profit-statement',
        {
          user: '',
          categoryType: 'all',
          startDate: fromDate.startOf('day').toISOString(),
          endDate: toDate.endOf('day').toISOString(),
          pageSize: pageSize,
          pageToken: pageToken[pageToken.length - 1],
        },
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
          params: {},
        }
      );
      if (response.status === 200) {
        setNextPageToken(response.data.nextPageToken);
        const pl_records = response?.data;
        setplStatement(new Map());
          // let total = pl_records[item].reduce((a, b) => a + b.profit, 0);
          // let totalPlMap = totalPL;
          // totalPlMap.set(item, total);
          // setTotalPL(totalPlMap);
          // setMyTotalProfit(myTotalProfit + total);
          // let plRecords = await getRecordsByPermision(pl_records[item]);
          let plRecords = pl_records?.plEntries;
          for (const pl of plRecords) {
            pl.profit = pl.profit / cFactor;
            pl.commission = pl.commission / cFactor;
          }
          let plRecordsMap = plStatement;
          plRecordsMap.set("plEntries", plRecords);
          setplStatement(plRecordsMap);
        setProgress(false);
      } else {
        setProgress(false);
        throw new Error(response.data);
      }
    } catch (err) {
      if (err.response && err.response.data) {
        setErrorMsg(err.response.data.error);
      }
      setProgress(false);
    }
  };

  useEffect(() => {
    fetchPLStatement();
  }, [fromDate, toDate, pageToken]);

  const fromDateChangeHandler = (d: Moment) => {
    setfromDate(d);
  };

  const toDateChangeHandler = (d: Moment) => {
    setToDate(d);
  };

  const nextPage = () => {
    setProgress(true);
    if (nextPageToken) {
      setPageToken([...pageToken, nextPageToken]);
    }
  };

  const prevPage = () => {
    setProgress(true);
    if (pageToken.length > 1) {
      let pagetokens = pageToken;
      pagetokens.pop();
      setPageToken([...pagetokens]);
    }
    setProgress(false);
  };

  return (
    <div className="reports-ctn user-pl-stmt-ctn">
      <div className="header-ctn pl-header-ctn">
        <IonRow>
          <div className="img-page-title-row">
            <IonIcon className="title-image" color="primary" src={AccStmtImg} />
            <div className="title">{langData?.['profit_loss']} {langData?.['statements']}</div>
          </div>

          <div className="user-pl-filters-row filters-row web-view">
            <div className="from-date-filter">
              <div className="date-label filter-label">{langData?.['from']}</div>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardDatePicker
                  disableFuture
                  className="date-filter date-control"
                  InputProps={{
                    disableUnderline: true,
                    readOnly: true,
                  }}
                  minDate={moment().subtract(1, 'months').calendar()}
                  disableToolbar
                  variant="inline"
                  format="DD/MM/yyyy"
                  margin="normal"
                  id="from-date"
                  value={fromDate}
                  onChange={(e) => fromDateChangeHandler(e)}
                />
              </MuiPickersUtilsProvider>
            </div>

            <div className="to-date-filter">
              <div className="date-label filter-label">{langData?.['to']}</div>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardDatePicker
                  disableFuture
                  className="date-filter date-control"
                  InputProps={{
                    disableUnderline: true,
                    readOnly: true,
                  }}
                  minDate={moment().subtract(1, 'months').calendar()}
                  disableToolbar
                  variant="inline"
                  format="DD/MM/yyyy"
                  margin="normal"
                  id="to-date"
                  value={toDate}
                  onChange={(e) => toDateChangeHandler(e)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>
        </IonRow>
      </div>

      <div className="user-pl-filters-row filters-row mob-view">
        <div className="from-date-filter">
          <div className="date-label filter-label">{langData?.['from']}</div>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <KeyboardDatePicker
              disableFuture
              className="date-filter date-control"
              InputProps={{
                disableUnderline: true,
                readOnly: true,
              }}
              minDate={moment().subtract(1, 'months').calendar()}
              disableToolbar
              variant="inline"
              format="DD/MM/yyyy"
              margin="normal"
              id="from-date"
              value={fromDate}
              onChange={(e) => fromDateChangeHandler(e)}
            />
          </MuiPickersUtilsProvider>
        </div>

        <div className="to-date-filter">
          <div className="date-label filter-label">{langData?.['to']}</div>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <KeyboardDatePicker
              disableFuture
              className="date-filter date-control"
              InputProps={{
                disableUnderline: true,
                readOnly: true,
              }}
              minDate={moment().subtract(1, 'months').calendar()}
              disableToolbar
              variant="inline"
              format="DD/MM/yyyy"
              margin="normal"
              id="to-date"
              value={toDate}
              onChange={(e) => toDateChangeHandler(e)}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </MuiPickersUtilsProvider>
        </div>
      </div>

      <div className="content-ctn light-bg">
        {errorMsg ? <Alert message={errorMsg} /> : ''}
        {progress ? (
          <Spinner />
        ) : (
          <>
            <ProfitLossStatement
              items={plStatement}
              startDate={fromDate}
              endDate={toDate}
              searchName={''}
            />
            <IonRow className="ml-5">
              {pageToken.length === 1 || progress ? null : (
                <IonButton className="myb-btn-prev" onClick={(e) => prevPage()}>
                  {langData?.['prev']}({pageToken.length - 1})
                </IonButton>
              )}
              {nextPageToken && !progress ? (
                <IonButton className="myb-btn-next" onClick={(e) => nextPage()}>
                  {langData?.['next']}({pageToken.length + 1})
                </IonButton>
              ) : null}
            </IonRow>
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    bettingCurrency: state.common.bettingCurrency,
    tvGamesEnabled: state.common.tvGamesEnabled,
    allowedConfig: state.common.allowedConfig,
    langData:state.common.langData
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchBettingCurrency: () => dispatch(fetchBettingCurrency()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPLStatement);
